export default __webpack_public_path__ + "static/media/tv1.63ba901f.jpeg";